
import { useState } from 'react';

const socialLinks = [
  { name: 'Facebook', icon: 'ri-facebook-fill', url: 'https://www.facebook.com/Hitscolletionstation' },
  { name: 'Instagram', icon: 'ri-instagram-fill', url: 'https://instagram.com' },
  { name: 'Twitter', icon: 'ri-twitter-x-fill', url: 'https://twitter.com' },
  { name: 'YouTube', icon: 'ri-youtube-fill', url: 'https://youtube.com' },
  { name: 'TikTok', icon: 'ri-tiktok-fill', url: 'https://tiktok.com' }
];

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5fp7m8f0tcnoht87110', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-16 sm:py-24 lg:py-32 bg-[#1a1a1a]">
      <div className="px-4 sm:px-8 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16">
          {/* Left Column - Information */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#d4af37] mb-4 sm:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              CONTÁCTANOS
            </h2>
            <p className="text-white/80 text-sm sm:text-base lg:text-lg mb-8 sm:mb-12 leading-relaxed">
              Estamos aquí para escucharte. Envíanos tus comentarios, sugerencias o solicitudes musicales. Tu opinión es muy importante para nosotros.
            </p>

            <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-12">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-[#d4af37] rounded-full text-[#d4af37] flex-shrink-0">
                  <i className="ri-mail-line text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Email</p>
                  <p className="text-white font-medium text-sm sm:text-base break-all">contacto@hitscollections.com</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-[#d4af37] rounded-full text-[#d4af37] flex-shrink-0">
                  <i className="ri-phone-line text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Teléfono</p>
                  <p className="text-white font-medium text-sm sm:text-base">+1 (555) 123-4567</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-[#d4af37] rounded-full text-[#d4af37] flex-shrink-0">
                  <i className="ri-map-pin-line text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Dirección</p>
                  <p className="text-white font-medium text-sm sm:text-base">Torres del Bosque, Ciudad de Cúcuta</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 text-base sm:text-lg">Síguenos en Redes Sociales</h3>
              <div className="flex flex-wrap gap-3 sm:gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-[#d4af37] text-[#d4af37] rounded-full hover:bg-[#d4af37] hover:text-black transition-all duration-300 cursor-pointer"
                    aria-label={social.name}
                  >
                    <i className={`${social.icon} text-lg sm:text-xl`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div>
            <form onSubmit={handleSubmit} data-readdy-form id="contact_form" className="space-y-4 sm:space-y-6">
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Tu Nombre"
                  required
                  className="w-full bg-transparent border-b-2 border-[#d4af37] text-white placeholder-gray-400 py-2 sm:py-3 focus:outline-none focus:border-white transition-colors duration-300 text-sm sm:text-base"
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Tu Email"
                  required
                  className="w-full bg-transparent border-b-2 border-[#d4af37] text-white placeholder-gray-400 py-2 sm:py-3 focus:outline-none focus:border-white transition-colors duration-300 text-sm sm:text-base"
                />
              </div>

              <div>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Asunto"
                  required
                  className="w-full bg-transparent border-b-2 border-[#d4af37] text-white placeholder-gray-400 py-2 sm:py-3 focus:outline-none focus:border-white transition-colors duration-300 text-sm sm:text-base"
                />
              </div>

              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tu Mensaje"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full bg-transparent border-b-2 border-[#d4af37] text-white placeholder-gray-400 py-2 sm:py-3 focus:outline-none focus:border-white transition-colors duration-300 resize-none text-sm sm:text-base"
                ></textarea>
                <p className="text-gray-500 text-xs mt-2">{formData.message.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#d4af37] text-black font-bold py-3 sm:py-4 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 flex items-center justify-center gap-2 text-xs sm:text-sm uppercase whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'ENVIANDO...' : 'ENVIAR MENSAJE'}
                <i className="ri-arrow-right-line text-base sm:text-lg"></i>
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500 text-green-500 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                  ¡Mensaje enviado con éxito! Te responderemos pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500 text-red-500 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                  Error al enviar el mensaje. Por favor, intenta de nuevo.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
